import React from 'react';
import { Card } from '../../ui/card';
import PlayerIdentity from './PlayerIdentity';

// PlayerHeader: who the result is for (simple view).
export default function PlayerHeader({ player, backofficeUrl }) {
  return (
    <Card className="px-5 py-3.5">
      <PlayerIdentity player={player} backofficeUrl={backofficeUrl} />
    </Card>
  );
}
